<template>
  <div class="main-container">
    <Sidebar />
    <div class="main">
      <Navbar />
      <Content />
    </div>
  </div>
</template>

<script>
  import Sidebar from "../partials/Sidebar";
  import Navbar from "../partials/Navbar";
  import Content from "../partials/Content";
  export default {
    name: "Layout",
    components: {
      Sidebar,
      Navbar,
      Content,
    },
  };
</script>

<style lang="scss" scoped>
  .main-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100vh;
    background: #f5f5f5;

    .main {
      display: flex;
      flex-direction: column;
      width: 100%;
      min-height: 100vh;
      overflow-y: auto;
    }
  }
</style>
